import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHNivelIns = async (credentials, data) => {
    const body = {
        service: "RNHNivelIns",
        params: {
            rnhNivelCod: data?.cod || null,
            rnhNivelNombre: data?.name || null,
            rnhTipoComponenteCod: data?.maxLevel || null
        },
    };

  return respuestaDe(await axiosPost(body, credentials));
};
